<template>
  <footer class="footer">
    {{$t('footer-web.text')}} <br class="no_desktop"/> {{$t('footer-web.text-2')}}
  </footer>
</template>

<script>
export default {

}
</script>

<style>

</style>